<template>
	<div class="modal fade" id="modal-feriados">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">Feriado</h4>
					<button type="button" class="close" data-dismiss="modal">
						<img :src="logotipo" style="width: 30px; height: 35px; opacity: 1;">
						&times;
					</button>
				</div>

				<div class="modal-body">

					<div class="row">
						<div class="col-md-8">
							<div class="form-group">
								<label>Nome</label>
					        	<input type="text" id="nome" class="form-control form-control-sm" v-model="feriado.nome">
							</div> 
						</div>

						<div class="col-md-4">
							<div class="form-group">
								<label  for="delito">Data</label>
					        	<input type="text" id="dia" class="form-control form-control-sm" v-model="feriado.dia" v-mask="['##/##']">
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<button v-if="feriado.id" class="btn btn-sm btn-danger" @click="delet">Excluir</button>
					<button class="btn btn-sm btn-success" @click="save">Salvar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api     from "@/mixins/api.js"
	import replace from "@/mixins/replace.js"

	export default {
		name: "modal-feriados",
		props: [ 'feriado' ],
		mixins: [ api, replace ],

		computed: {
			logotipo() { 
				return this.$store.state.config.logotipo;
			},

			usuario()  { 
				return this.$store.state.user;
			}
		},

		methods: {
            save(){
                const aux = this.feriado.dia.split("/");
                this.feriado.dia = aux[0];
                this.feriado.mes = aux[1];
                if(aux[0].length == 2 && aux[1].length ==2){
                    if ( this.feriado.id ) {
                        this.update();
                    }else{ 
                        this.create();
                    }
                }else{
					alert('Digite uma data valida exemplo: "01/10"');
				}
            },

			async update() {
				const response = await this.PUT("Feriados", this.feriado);

				if ( response.status == "success"){
					this.$emit("alert", { status: "success", result: "Dados atualizados com sucesso."} );
				}else{
					window.alert(response.result);
				}
            },

            async create() {
                const response = await this.POST("Feriados", this.feriado);

				if ( response.status == "success"){
                    this.$emit("alert", { status: "success", result: "Dados inseridos com sucesso."} );
                }else{ 
                    window.alert(response.result);
                }
            },

            async delet() {
                const response = await this.DELETE("Feriados", this.feriado.id);

                if ( response.status == "success"){
					this.$emit("alert", { status: "success", result: "Dados deletados com sucesso."} );
				}else{
					window.alert(response.result);
				}
            },
		}
	}
</script>

<style scoped>
</style>